import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SurveyDetailPage } from '@apps/web/components/surveys/survey_detail_page';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';

const surveyDetailsSearchSchema = z.object({
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/surveys/$survey-id')({
    head: () => ({
        meta: [{ title: 'Survey Details | Phoebe' }],
    }),
    validateSearch: surveyDetailsSearchSchema,
    component: SurveyDetailRoute,
});

function SurveyDetailRoute() {
    const { 'survey-id': surveyId } = Route.useParams();
    const { organizationId, mode } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        organizationId,
        mode,
    );
    return isWaitingForDeepLinkOrganization ? null : (
        <SurveyDetailPage surveyId={surveyId} />
    );
}
